import request from '../request.js'

// 主体使用者：获取主体待选择人员信息（张卫华）
const getUserTenantTablePageListByTenantId = function (data) {
    return request({
        url: 'sysUserTenant/getUserTenantTablePageListByTenantId',
        method: 'post',
        data
    })
}
// 租户使用者：获取租户待选择人员信息（张卫华）
const getUnUserTenantTablePageList = function (data) {
    return request({
        url: 'sysUserTenant/getUnUserTenantTablePageList',
        method: 'post',
        data
    })
}
// 批量保存用户信息（导入）（张卫华）
const saveUserTenantBatch = function (data) {
    return request({
        url: 'sysUserTenant/saveUserTenantBatch',
        method: 'post',
        data
    })
}
// 修改人员启用状态（张卫华）
const updateUserTenantOrEnable = function (data) {
    return request({
        url: 'sysUserTenant/updateUserTenantOrEnable',
        method: 'post',
        data
    })
}
// 根据id，删除（张卫华）
const deleteBy2Id = function (data) {
    return request({
        url: 'sysUserTenant/deleteBy2Id',
        method: 'post',
        data
    })
}

//平台用户管理-获取待选人员列表（张卫华）
const getPlatformUnUserTablePageList = function (data) {
    return request({
        url: 'sysUserTenant/getPlatformUnUserTablePageList',
        method: 'post',
        data
    })
}
//平台用户管理-导入用户（张卫华）
const savePlatformUserTenantBatch = function (data) {
    return request({
        url: 'sysUserTenant/savePlatformUserTenantBatch',
        method: 'post',
        data
    })
}

export {
    getUserTenantTablePageListByTenantId,
    getUnUserTenantTablePageList,
    saveUserTenantBatch,
    updateUserTenantOrEnable,
    deleteBy2Id,
    getPlatformUnUserTablePageList,
    savePlatformUserTenantBatch,
}